import type { DatasetElement } from '@app-types/common.types'
import { queryAll } from 'lambda-dom'

/**
 * Legacy widget ported from javascript, used for variant reviews from the detail page.
 */
export class LegacyRatingWidget {

    /**
     * Assigns a global reference to the class constructor to window, used from
     * some old blade partials.
     */
    static patchWindow() {
        Object.assign(window, { LegacyRatingWidget })
    }

    ratingContainer: HTMLElement
    stars: HTMLElement[]
    input: HTMLInputElement
    currentIndex: number = -1

    constructor(containerId: string) {
        this.ratingContainer = document.getElementById(containerId)!
        this.stars = queryAll<DatasetElement<{ rating: string }>>('.star', this.ratingContainer)
        this.input = this.ratingContainer.querySelector<HTMLInputElement>('input[name="rating"]')!
        this.attachEvents()
    }

    attachEvents() {

        this.stars.forEach((iStar, i) => {

            iStar.addEventListener('mouseenter', () => {
                this.stars.forEach((jStar, j) => jStar.classList.toggle('active', j <= i))
            })

            iStar.addEventListener('click', () => {
                this.currentIndex = i
                this.input.value = iStar.dataset.rating!
            })
        })

        this.ratingContainer.addEventListener('mouseleave', () => {
            this.stars.forEach((star, i) => {
                star.classList.toggle('active', i <= this.currentIndex)
            })
        })
    }
}
